import SelectableCardGroup from './common/SelectableCardGroup';

const CHOICES = [
  { key: 'pressure', title: '부담스러운 영업', desc: '눈치 보지 않고 여유롭게 둘러보고 싶어요', icon: 'ri-shield-user-line' },
  { key: 'mismatch', title: '어울리지 않는 스타일 추천', desc: '트렌드보다는 내 체형과 분위기에 맞는 추천을 원해요', icon: 'ri-user-unfollow-line' },
  { key: 'cost', title: '예상보다 커지는 비용', desc: '숨은 비용 없이 처음 안내된 예산대로 끝내고 싶어요', icon: 'ri-money-cny-circle-line' },
  { key: 'wait', title: '긴 대기와 복잡한 과정', desc: '피팅부터 수령까지 과정이 간결하고 예측 가능했으면 해요', icon: 'ri-time-line' },
  { key: 'quality', title: '기대보다 아쉬운 퀄리티', desc: '사진과 실물의 차이, 수선 후 마감 등이 걱정돼요', icon: 'ri-image-line' },
];

interface StepAvoidProps {
  value: string | null;
  onChange: (val: string) => void;
}

export default function StepAvoid({ value, onChange }: StepAvoidProps) {
  return <SelectableCardGroup options={CHOICES} value={value} onChange={onChange} />;
}
